<div class="faq-content-block">
    <!-- connect with saradha about this comment -->
    <!--  <a class="faq-text-block" href="javascript:void(0);" *ngIf="windowWidth >= 1200" (click)="openFAQDialog();">
        <span class="faq-text">FAQ</span>
         <img width="75" alt="FAQ" class="faq-icon" [src]="faqImageURL">
    </a> -->

    <button *ngIf="windowWidth >= 1200" class="btn faq-btn" type="button" (click)="openFAQDialog();">
        FAQ
    </button>

    <button *ngIf="windowWidth < 1200" class="btn faq-btn" type="button" (click)="openFAQDialog();">
        FAQ
    </button>
    <!--  <a *ngIf="windowWidth < 1200" (click)="openFAQDialog()" color="warn" href="javascript:void(0);">
        <img width="50" alt="FAQ" class="faq-icon" [src]="faqImageURL">
    </a> -->
</div>